import { DARK_MODE, ROOT_SCOPE } from './constants';
export const boxShadowTheme = {
    down4: '0px 4px 10px 0px rgba(0, 0, 0, calc(0.04 + var(--shadow-dark-opacity, 0)))',
    down6: '0px 4px 16px 0px rgba(0, 0, 0, calc(0.14 + var(--shadow-dark-opacity, 0)))',
    down8: '0px 6px 22px 0px rgba(0, 0, 0, calc(0.24 + var(--shadow-dark-opacity, 0)))',
    up4: '0px -4px 10px 0px rgba(0, 0, 0, calc(0.04 + var(--shadow-dark-opacity, 0)))',
    up8: '0px -8px 16px 0px rgba(0, 0, 0, calc(0.14 + var(--shadow-dark-opacity, 0)))',
    up12: '0px -12px 22px 0px rgba(0, 0, 0, calc(0.24 + var(--shadow-dark-opacity, 0)))',
    right4: '4px 0px 10px 0px rgba(0, 0, 0, calc(0.04 + var(--shadow-dark-opacity, 0)))',
    left4: '-4px 0px 10px 0px rgba(0, 0, 0, calc(0.04 + var(--shadow-dark-opacity, 0)))'
};
export const blurShadowTheme = {
    b12: {
        boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, calc(0.04 + var(--shadow-dark-opacity, 0)))',
        backdropFilter: 'blur(6px)'
    },
    b26: {
        boxShadow: '0px 8px 16px 0px rgba(0, 0, 0, calc(0.14 + var(--shadow-dark-opacity, 0)))',
        backdropFilter: 'blur(13px)'
    },
    b40: {
        boxShadow: '0px 12px 22px 0px rgba(0, 0, 0, calc(0.24 + var(--shadow-dark-opacity, 0)))',
        backdropFilter: 'blur(20px)'
    }
};
export const shadowBase = {
    [ROOT_SCOPE]: { '--shadow-dark-opacity': '0' },
    [DARK_MODE]: { '--shadow-dark-opacity': '0.1' }
};
